import {
  ProgressCardInfoCell,
  ProgressCardView,
} from '@euler/app/tv/components/detail/ProgressCardView';
import { InspectionTaskJobStatus } from '@euler/model/enum';
import { TaskDetail } from '@euler/model/task-detail';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const ConstructionProgressView = memo(
  ({
    detail,
    style,
    onPress,
  }: {
    detail: TaskDetail;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
  }) => {
    return (
      <ProgressCardView
        title="施工反馈"
        status={detail.construction.status}
        statusButtonInProgressText={'施工中'}
        index={0}
        style={style}
        onPress={onPress}
      >
        <ProgressCardInfoCell
          label="已派工项目"
          value={detail.construction.jobs.length}
        />
        <ProgressCardInfoCell
          label="已完成项目"
          value={
            detail.construction.jobs.filter(
              x => x.status === InspectionTaskJobStatus.Finished,
            ).length
          }
        />
        <ProgressCardInfoCell
          label="待施工项目"
          value={
            detail.construction.jobs.filter(
              x => x.status === InspectionTaskJobStatus.Pending,
            ).length
          }
        />
      </ProgressCardView>
    );
  },
);
